/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  REQUEST_PROBES,
  FETCH_PROBES,
  FETCH_PROBES_SUCCESS,
  FETCH_PROBES_FAILURE, 
  POLL_PROBES_START,
  POLL_PROBES_STOP
} from './actionTypes'
// import probes from '../../api/mcs/probes'
import { ProbesList } from './probesList'

export function requestProbes() {
  return {
    type: REQUEST_PROBES
  }
}

export function fetchProbesSuccess(json) {
  return {
    type: FETCH_PROBES_SUCCESS,
    probes: json
  }
}

export function fetchProbesFailure(error) {
  return {
    type: FETCH_PROBES_FAILURE,
    errorMessage: error.message
  }
}

export function fetchProbes(count,useEnhancedTemplates,categories) {
  return dispatch => {
    dispatch(fetchProbespoll(useEnhancedTemplates,categories))
    return ProbesList.fetchProbeDetails({count:count,useEnhancedflag:useEnhancedTemplates,categories})
      .then(response => response.data)
      .then(json => dispatch(fetchProbesSuccess(json)))
      .catch(function (error) {
        dispatch(fetchProbesFailure(error))
      })
  }
}
export function fetchProbespoll(useEnhancedTemplates,categories) {
  return {
    type:FETCH_PROBES,
    count:false,
    useEnhancedflag:useEnhancedTemplates,
    categories:categories
  }
}

export function pollProbesStart(useEnhancedTemplates,categories) {
 // console.log("Start polling Probes")
  return {
    type:POLL_PROBES_START,
    count:true,
    useEnhancedflag:useEnhancedTemplates,
    categories:categories
  }
}
export function pollProbesStop() {
 // console.log("Stop polling Probes")
  return {
    type:POLL_PROBES_STOP,
    count:true,
  }
} 